// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1X6QP","col":"styles_col__36pSP","fulfillmentStatus":"styles_fulfillmentStatus__1V6bK","emailCol":"styles_emailCol__1AVCH"};